<template>
  <div class="fake"></div>
</template>

<script>
  import * as shaka from 'shaka-player';
  import { itemList } from '@/utils/settings.options';
  import SettingStorage from '@/utils/settings.storage';
  import cardsService from '@/services/cards.service';
  import LiveService from '@/services/live.service';
  import { Events } from '@/models/analytics';

  export default {
    props: {
      videoId: {
        type: String,
        required: true,
      },
      videoUrl: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        videoBaseUrl: process.env.VUE_APP_VIDEO_BASE_URL,
        video: null,
        videoInfo: null,
        shakaPlayer: null,
        listItems: [],
        videoIdPlaying: '',
        isPlaying: true,
        videoFormats: [],
        formatMap: {
          HLS: 1,
          DASH: 2,
          MP4: 3,
        },
        isUserPremium: this.getPremium,
      };
    },
    computed: {
      videoList() {
        return this.$store.getters['settings/videoList'];
      },
      getTime() {
        return this.$store.getters['settings/getTime'];
      },
      getLiveMode() {
        return this.$store.getters['settings/getLiveMode'];
      },
      getContentType() {
        return this.$store.getters['settings/getContentType'];
      },
      getAge() {
        return this.$store.getters['settings/getAge'];
      },
      getPremium() {
        return this.$store.getters['account/getPremium'];
      },
    },
    watch: {
      videoInfo (newVideo, oldVideo) {
        if (this.getToken !== false && localStorage.getItem('kidj_ut')) {
          if (newVideo?.id && (oldVideo?.id === this.$route.params.videoId || newVideo?.id === this.$route.params.videoId)) {
            this.$store.dispatch('analytics/updateAnalyticsMedia', this.videoInfo);
            this.$store.dispatch('analytics/postAnalytics', Events.CLICK, { root: true });
          }
        }
      }
    },
    methods: {
      async getVideoInfo() {
        if (this.getToken !== false && localStorage.getItem('kidj_ut') && this.videoInfo?.id) {
          this.$store.dispatch('analytics/postAnalytics', Events.CLOSE, { root: true });
          this.$store.dispatch('analytics/resetAnalyticsGameMedia', {});
        }
        await cardsService.getVideoById(this.videoIdPlaying).then((data) => {
          this.videoInfo = data;
        });
      },
      setVideoList(list) {
        this.$store.dispatch('settings/setVideoList', list);
      },
      async launchNewVideo() {
        if (this.videoList[0] != null || this.getLiveMode) {
          if (this.videoList[0] == null) {
            const type = this.getContentType;
            const age = this.getAge;
            const lang = SettingStorage.getOptionValue(itemList.language);
            const itemsList = await LiveService.getVideosIds(type, age);
            this.setVideoList(itemsList);
          }

          this.videoIdPlaying = this.videoList[0].identifier;
          this.listItems = this.videoList.slice(1);
          this.setVideoList(this.listItems);
          this.video.resetAndClean();
          await this.getVideoInfo();
          this.videoFormats = this.videoInfo.formats;
          this.$ga.event('video', 'play', `${this.videoIdPlaying}`);
          this.$router.replace({ name: 'player', params: { videoId: this.videoIdPlaying } });

          if (await this.loadUrl()) {
            this.video.play();
          }
        }
      },
      getCompletionRoundValue() {
        // eslint-disable-next-line no-mixed-operators
        const completion = Math.ceil(this.video.currentTime * 1.0 / this.video.duration * 100);
        if (completion === 100) {
          return '100';
        }
        if (completion >= 75) {
          return '75';
        }
        if (completion >= 50) {
          return '50';
        }
        if (completion >= 25) {
          return '25';
        }

        return '0';
      },
      handlePlayerKeydown(event) {
        event.preventDefault();
      },
      handleKeyboard(event) {
        event.preventDefault();
        if (this.video && this.getTimeLimit > 0) {
          try {
            switch (event.keyCode) {
              case VK_PLAY: {
                this.isPlaying = true;
                this.video.play();
                break;
              }
              case VK_PAUSE: {
                this.isPlaying = false;
                this.video.pause();
                break;
              }
              case VK_ENTER: {
                if (this.isPlaying) {
                  this.isPlaying = false;
                  this.video.pause();
                } else {
                  this.isPlaying = true;
                  this.video.play();
                }
                break;
              }
              case VK_REWIND: {
                this.video.currentTime = this.video.currentTime - 5;
                break;
              }
              case VK_LEFT: {
                this.video.currentTime = this.video.currentTime - 5;
                break;
              }
              case VK_FAST_FWD: {
                this.video.currentTime = this.video.currentTime + 10;
                break;
              }
              case VK_RIGHT: {
                this.video.currentTime = this.video.currentTime + 10;
                break;
              }
            }
          } catch (error) {
            // Vewd TV events not supported
          }
        }
      },
      async initPlayer() {
        const player = new shaka.Player(this.video);
        player.addEventListener('error', this.onErrorEvent);
        this.shakaPlayer = player;

        // Try to load a manifest.
        // This is an asynchronous process.
        if (await this.loadUrl()) {
          this.video.play();
        }
      },
      async loadUrl() {
        if (this.videoUrl != null) {
          try {
            if (VK_0) {
              this.video.src = this.videoUrl;
              return this.video.play().then(() => {
                return true;
              }).catch((error) => {
                return false;
              });
            } else {
              throw  new Error('Error loading the video');
            }
          } catch (error) {
            return this.playUrl(this.videoUrl);
          }
        } else if (this.videoIdPlaying != null) {
          // Generate video urls from formta href
          let urls = this.generateVideoUrls();

          if (urls.length === 0) {
            urls = [this.computeUrl(this.videoIdPlaying, 2), this.computeUrl(this.videoIdPlaying, 3), this.computeUrl(this.videoIdPlaying, 1)];
          }

          for (const url of urls) {
            try {
              if (VK_0) {
                this.video.play().then(() => {
                  return true;
                }).catch((error) => {
                  return false;
                });
              }
            } catch (error) {

              if (await this.playUrl(url)) {
                return true;
              }
            }
          }

          this.video.src = this.computeUrl(this.videoIdPlaying, 3);

          return this.video.play().then(() => {
            return true;
          }).catch((error) => {
            throw new Error('Error loading the video');
          });
        } else {
          throw new Error('No correct id or url provided');
        }
      },
      async playUrl(url) {
        return new Promise((resolve, reject) => {
          this.shakaPlayer.load(url).then(() => {
            resolve(true);
          }).catch((error) => {
            resolve(false);
          });
        });
      },
      computeUrl(identifier, format) {
        // Examples:
        // https://d23sw6prl9jc74.cloudfront.net/1/3GvP5B1X9d/3GvP5B1X9d.m3u8
        // https://d23sw6prl9jc74.cloudfront.net/2/3GvP5B1X9d/3GvP5B1X9d.mpd
        // https://d23sw6prl9jc74.cloudfront.net/3/3GvP5B1X9d.mp4
        const { formatMap } = this;
        const extension = format === formatMap.HLS ? '.m3u8' : format === formatMap.DASH ? '.mpd' : '.mp4';
        const path = format === formatMap.HLS || format === formatMap.DASH ? `/${identifier}/${identifier}${extension}` : `/${identifier}${extension}`;
        return `${this.videoBaseUrl}/${format}${path}`;
      },
      generateVideoUrls() {
        const urls = [];

        for (const format of this.videoFormats) {
          urls.push(this.videoBaseUrl + '/' + format.href);
        }

        return urls;
      },
      onErrorEvent(event) {
        // TODO: error display
      },
    },
    async mounted() {
      const anyDocument = document;
      this.video = anyDocument.videoPlayer;
      this.video.addEventListener('ended', this.launchNewVideo);
      this.videoIdPlaying = this.videoId;

      await this.getVideoInfo();
      this.videoFormats = this.videoInfo.formats;

      if (!this.getPremium && this.videoInfo.premium) {
        const params = new URLSearchParams(window.location.search);
        if (params.has('vewd') && params.has('folderId')) {
          this.$router.replace({ path: ('/folder/' + params.get('folderId')), query: { showBanner: 'true' } });
        } else {
          this.$router.replace({ name: 'home', query: { showBanner: 'true' } });
        }
      }

      // Check to see if the browser supports the basic APIs Shaka needs.
      try {
        if (VK_0) {
          if (await this.loadUrl()) {
            this.video.play();
          }
        }
      } catch (error) {
        shaka.polyfill.installAll(); // DEV NOTE: check this for the required polyfills

        if (shaka.Player.isBrowserSupported()) {
          // Install built-in polyfills to patch browser incompatibilities.
          // Everything looks good!
          await this.initPlayer();
        } else {
          // This browser does not have the minimum set of APIs we need.
          // Fallback to classic video tag
          this.video.src = this.computeUrl(this.videoIdPlaying, 3);
          this.video.play();
        }
      }
      document.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('keyup', this.handleKeyboard);
    },
    async destroyed() {
      document.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('keyup', this.handleKeyboard);
      this.video.removeEventListener('ended', this.launchNewVideo);
      
      if (this.getToken !== false && localStorage.getItem('kidj_ut')) {
        this.$store.dispatch('analytics/postAnalytics', Events.CLOSE, { root: true });
        this.$store.dispatch('analytics/resetAnalyticsGameMedia', {});
      }
      const completion = this.getCompletionRoundValue();
      this.$ga.event('video', 'watch', completion);

      // Reset video player
      setTimeout(() => {
        this.video.resetAndClean();
      }, 200);

      try {
        if (VK_0) {
          // Empty block to detect vewd TV
        }
      } catch (error) {
        this.shakaPlayer.destroy();
      }
    },
  };
</script>
